export default __webpack_public_path__ + "static/media/UdunkuluLogo1.d5930db6.svg";